import { Col, Container, Row, Image } from "react-bootstrap"
import "./About.css";
import aboutImg from "../assets/img/about.jpg";

export const About = ({ contentData }) => {
    return (
        <div className="about-container bg-light py-5" id="about">
            <Container>
                <Row className="about-content align-items-center">
                    <Col className="d-flex flex-column-reverse flex-lg-row align-items-center">
                        <div>
                            <Image className="about-img rounded mt-3 mx-2" src={aboutImg} />
                        </div>
                        <div className="mx-1 text-center text-lg-start about-text border-start border-2 px-2">
                            <h1 className="esd-font s-header">About Me</h1>
                            <p>{contentData.aboutMeIntro}</p>
                            <p>{contentData.aboutMeSkills}</p>
                            <p>{contentData.aboutMeInterest}</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}